import React from 'react';
import Link from '../TextLink';
import classnames from 'classnames';

const Attribution = ({ attribution, className }: any) => {
  if (!attribution) return null;

  if (!attribution.href || attribution.href === '') {
    return <p className={classnames('text-base', className)}>Published by {attribution.text}</p>;
  }

  return (
    <p className={classnames('text-base', className)}>
      Published by{' '}
      <Link to={attribution.href} color="primary">
        {attribution.text}
      </Link>
    </p>
  );
};

export default Attribution;
